export interface LineColor {
  css: string;
  name: string;
}

const colors = ['60', '40', '80', '50', '70'].flatMap((variant) =>
  ['turquoise', 'purple', 'blue', 'yellow', 'orange', 'green', 'red', 'neutral'].map((color) => ({ color, variant })),
);

const getLineColor = (index: number): LineColor => {
  const { color, variant } = colors[index % colors.length];

  return {
    css: `var(--colors-${color}-${variant})`,
    name: `${color}.${variant}`,
  };
};

export default getLineColor;
